<template>
	<vue-scrollbar color="#666" width="8px" :top="true" ref="scrollbar">
		<el-row class="hand-nav">
			<el-menu mode="horizontal" ref="menu" :default-active="activeIndex" :active="activeIndex"
				class="el-menu-demo" router @select="handleSelect" :unique-opened="true" background-color="#f2f2f2"
				text-color="#000" active-text-color="#007985">
				<el-menu-item index="/" style="border-bottom: 0px;">
					<img src="../../public/images/12.svg" style="height: 50px;vertical-align: middle;" />
				</el-menu-item>
				<el-menu-item index="/">
					首页
				</el-menu-item>
				<el-submenu index="3">
					<template slot="title">产品中心 </template>
					<vue-head-menu title="教学产品" :menu="headMenu" @click="$refs.menu.close('3')">
					</vue-head-menu>
				</el-submenu>
				<el-submenu index="7">
					<template slot="title">经典案例</template>
					<!-- <el-menu-item index="/home/classic-case/page2"> 北京大学 </el-menu-item> -->
					<el-menu-item index="/home/classic-case/page1"> 本科案例 </el-menu-item>
					<el-menu-item index="/home/classic-case/page2"> 职教案例 </el-menu-item>
					<el-submenu index="2-4">
						<template slot="title">1+X技能大赛</template>
						<el-menu-item index="/home/classic-case/page4">中药技能大赛</el-menu-item>
						<el-menu-item index="/home/classic-case/page3">BI技术应用大赛</el-menu-item>
					</el-submenu>
				</el-submenu>
				<!-- <el-submenu index="2">
					<template slot="title">解决方案</template>
					<vue-head-menu style="width: 600px;" :menu="headMenu2" @click="$refs.menu.close('2')">
					</vue-head-menu>
				</el-submenu>
				<el-menu-item index="/home/policy-dynamic">
					政策动态
				</el-menu-item> -->
				<el-menu-item index="/home/yrxm">
					协同育人
				</el-menu-item>
				<el-submenu index="6">
					<template slot="title">关于易格</template>
					<el-menu-item index="/home/site/company">公司简介</el-menu-item>
					<!-- <el-menu-item index="/home/site/honor">荣誉资质</el-menu-item> -->
					<el-menu-item index="/home/site/school">合作院校</el-menu-item>
					<el-menu-item index="/home/site/news">新闻动态</el-menu-item>
					<el-menu-item index="/home/site/history">发展历程</el-menu-item>
					<el-menu-item index="/home/site/contact">联系我们</el-menu-item>
				</el-submenu>
				<!-- <el-menu-item index="/home/site/contact">
					联系我们
				</el-menu-item> -->
				<el-menu-item class="not-bgcolor not-Mouse-hand" style="float: right;border-bottom: 0px;">
					<el-col class="hotlinePhone">
						<i class="el-icon-phone-outline" style="font-size: 30px;padding-right: 15px;"></i>
						<span>400-810-4006</span>
					</el-col>
				</el-menu-item>
			</el-menu>
		</el-row>
		<el-row>
			<router-view />
		</el-row>
		<el-row>
			<div class="bg-purple"
				style="min-height: 150px;text-align: center;background-color: #000;color: #fff;font-size: 30px;">
				<div class="footer">
					<div class="main">
						<div class="had">
							<el-row>
								<el-col :span="12">
									<el-row class="log_row">
										<el-col :span="6">
											<img src="../../public/images/12.svg" style="height: 80px;" />
										</el-col>
										<el-col :span="6">
											北京易格通智仿真
										</el-col>
										<el-col :span="12">
											服务 合作 VR虚拟仿真实验建设专业提供商
										</el-col>
									</el-row>
									<el-row class="address">
										<el-col>地址：北京市海淀区上地东路</el-col>
										<el-col>全国服务热线：400-810-4006</el-col>
										<el-col>业务咨询电话：177-0130-1115（王老师）</el-col>
									</el-row>
									<!-- <el-row class="address">
										<el-col>销售：13269100820</el-col>
									</el-row> -->
								</el-col>
								<el-col :span="6">
									<el-row class="link">
										<el-col class="title">友情链接</el-col>
										<el-col><a href="http://web.yigee.cn/login/index.html"
												target="_blank">智慧云仿真管理平台</a> </el-col>
										<el-col><a href="https://www.mosoink.com" target="_blank">北京蓝墨</a> </el-col>
										<el-col><a href="http://www.ilab-x.com/" target="_blank">实验空间</a> </el-col>
										<el-col><a href="/home/site/contact">联系我们</a></el-col>
									</el-row>
								</el-col>
								<el-col :span="6">
									<el-row>
										<el-col style="line-height: 80px;font-size: 16px;">
											关注易格公众号
										</el-col>
										<el-col>
											<img src="../../public/images/weixinerweima.jpg"
												style="width: 200px;height: 200px;" />
										</el-col>
									</el-row>
								</el-col>
							</el-row>
						</div>
						<div class="dwo">
							<p><a href="http://beian.miit.gov.cn/" target="_blank"
									style="color: #bbbbbb">京ICP备14018031号-1</a></p>
							<p>
								© 2023 虚拟现实和虚拟仿真专家-北京易格通智
								<a href="http://beian.miit.gov.cn/" target="_blank"><img src="../assets/shgs.png"></a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</el-row>
		<div
			style=" position: fixed; right: 30px; width: 48px; min-height: 48px; top: 50%; transform: translateY(-50%); z-index: 100; ">
			<div
				style=" padding: 15px; border-radius: 24px; background: #fff; box-shadow: 0 2px 15px 0 rgb(0 0 0 / 10%); display: inline-block;font-size: 20px;color: #666; text-align: center;">
				<div>
					<el-tooltip content="在线咨询" placement="left-start">
						<i class="el-icon-service" style="cursor: pointer;"
							@click="online_customer_service_isshow=true"></i>
					</el-tooltip>
					<div
						style="display: block;height: 1px;width: 100%;margin: 12px 0;background-color: #DCDFE6;position: relative;">
					</div>
					<el-tooltip content="QQ咨询" placement="left-start">
						<i class="el-icon-chat-dot-round" style="cursor: pointer;" @click="openQQ"></i>
					</el-tooltip>
					<div
						style="display: block;height: 1px;width: 100%;margin: 12px 0;background-color: #DCDFE6;position: relative;">
					</div>
					<el-tooltip content="留言" placement="left-start">
						<i class="el-icon-edit" style="cursor: pointer;"
							@click="$router.push('/home/site/contact')"></i>
					</el-tooltip>
				</div>
			</div>
		</div>
		<div v-if="online_customer_service_isshow"
			style="position: fixed; width: 376px; height: 476px; bottom: 20px;  right: 30px; z-index: 100; border-radius: 12px 12px 0px 0px; overflow: hidden; border: 2px solid rgb(255, 255, 255);box-shadow: 0 0 20px rgb(0 0 0 / 30%);">
			<iframe src="http://v.fmkefu.com/cs/jump?u=4377_4429&c=other&name=&desc=官网-售前咨询"
				style=" width: 100%; height: 100%; border: none; overflow: auto;  background: #fff;">
			</iframe>
			<el-link :underline="false" style="position: absolute;top: 8px;right: 8px;font-size: 18px;color: #eee;"
				@click="online_customer_service_isshow = false">
				<i class="el-icon-close"></i>
			</el-link>
		</div>
	</vue-scrollbar>
</template>

<script>
	document.title = "北京易格官网"

	import vueHeadMenu from '@/components/vue-head-menu'


	import img1 from '../assets/service.png'

	export default {
		components: {
			vueHeadMenu
		},
		data() {
			return {
				img1,
				activeIndex: '1',
				online_customer_service_isshow: false,
				headMenu: [{
					title: '技能大赛',
					children: [{
						title: '中药技能大赛',
						target: 'router',
						url: '/home/product2/zyjnds2'
					}, {
						title: '智慧零售',
						target: 'router',
						url: '/home/product2/details/05143696-f1d7-11ec-8d41-00163e0400dc'
					}]
				}, {
					title: '护理',
					children: [{
						title: '护理技术模拟教学系统',
						target: 'router',
						url: '/home/product2/details/0B4EDF5A-0E7E-4A33-9FF1-0C6902F240A7'
					}, {
						title: '养老服务与管理-居家环境设计',
						target: 'router',
						url: '/home/product2/details/1487f72a-938c-11ec-94bd-00163e0400dc'
					}, {
						title: '老年照护',
						target: 'router',
						url: '/home/product2/details/a94235b4-955c-11ec-abc1-00163e0400dc'
					}, {
						title: '护理临床思维培训及评测软件',
						target: 'router',
						url: '/home/product2/details/cdf2e701-938c-11ec-94bd-00163e0400dc'
					}]
				}, {
					title: '药学',
					children: [{
						title: '药房管理',
						target: 'router',
						url: '/home/product2/details/97473E03-563D-4AAD-87DE-DFF0C96F0121'
					}, {
						title: '药店经营与管理',
						target: 'router',
						url: '/home/product2/details/00000000-FBFC-4DC2-A807-D4A51C2B9071'
					}, {
						title: '药品分析仪器',
						target: 'router',
						url: '/home/product2/details/F94E60CA-1FDE-4F85-8AD4-260863A356B4'
					}, {
						title: '天然药物化学',
						target: 'router',
						url: '/home/product2/details/d1ce704c-955d-11ec-abc1-00163e0400dc'
					}, {
						title: '中药鉴别',
						target: 'router',
						url: '/home/product2/details/5387544C-47A0-48EA-A364-E3B0CA67EF38'
					}, {
						title: '中药炮制',
						target: 'router',
						url: '/home/product2/details/7CCB09A8-9A8B-4C27-8D02-71F4966A9A50'
					}, {
						title: 'GSP药品经营质量管理规范模拟教学软件',
						target: 'router',
						url: '/home/product2/details/EF63758A-8DEF-4CAF-BCAC-FABC6972B418'
					}, {
						title: '西药房（医院场景）管理虚拟仿真实训系统',
						target: 'router',
						url: '/home/product2/details/22794b0f-3dcd-11eb-b23d-00163e0400dd'
					}]
				}, {
					title: '平台',
					children: [{
						title: '智慧教育云仿真实验教学平台',
						target: 'router',
						url: '/home/product2/details/fc304f0d-f1ee-11ec-8d41-00163e0400dc'
					},{
						title: '墨影数字教师平台',
						target: 'router',
						url: '/home/product2/myszjspt'
					}]
				}, {
					title: '土木',
					children: [{
						title: '建筑材料实验',
						target: 'router',
						url: '/home/product2/details/123B6D4F-6D98-45DF-8708-8E914338B910'
					}, {
						title: '建筑施工技术',
						target: 'router',
						url: '/home/product2/details/21E33021-B461-46C8-8A96-AB7D57AAAB93'
					}, {
						title: '建筑给排水',
						target: 'router',
						url: '/home/product2/details/91DD52B5-00CF-454A-86E8-051C55C1D044'
					}, {
						title: '建筑工程测量与放线',
						target: 'router',
						url: '/home/product2/details/eade762f-9387-11ec-94bd-00163e0400dc'
					}]
				}, {
					title: 'Zspace/AR/VR',
					children: [{
						title: 'VR易课程',
						target: 'link',
						url: 'http://yigee.cn/vr/index.html'
					}, {
						title: 'AR易课程',
						target: 'link',
						url: 'http://yigee.cn/ar/index.html'
					}]
				}, {
					title: '申报服务',
					children: [{
						title: '国家级虚拟仿真一流课程',
						target: 'router',
						url: '/home/program/page8'
					}, {
						title: '国家级示范性虚拟仿真实训基地',
						target: 'router',
						url: '/home/program/page10'
					}]
				}, {
					title: '专业软件',
					children: [{
						title: '融智云考',
						target: 'link',
						url: 'https://www.cctrcloud.com'
					}, {
						title: '科研软件',
						target: 'link',
						url: 'http://www.sciencesoftware.com.cn'
					}, {
						title: 'ODEON',
						target: 'router',
						url: '/home/product2/details/016816ba-eaf4-11ec-8d41-00163e0400dc'
					}]
				}],
				headMenu2: [{
					title: '本科教育解决方案',
					children: [{
						title: '国家级一流课程建设方案',
						target: 'router',
						url: '/home/program/page8'
					}, {
						title: '虚拟仿真实训室建设方案',
						target: 'router',
						url: '/home/program/page9'
					}]
				}, {
					title: '职业教育解决方案',
					children: [{
						title: '医学虚拟仿真实训室建设',
						target: 'router',
						url: '/home/program/page3'
					}, {
						title: '国家级示范性实训基地建设',
						target: 'router',
						url: '/home/program/page10'
					}]
				}]
			};

		},
		watch: {
			$route(val) {
				this.$refs.scrollbar.scrolltop()
			}
		},
		methods: {
			handleSelect(key, keyPath) {
				document.documentElement.scrollTop = 0
				// console.log(key, keyPath);
			},
			openQQ() {
				window.open('http://wpa.qq.com/msgrd?v=3&uin=3249264630&site=qq')
			}
		}
	}
</script>
<style>
	.hand-nav {
		position: sticky;
		top: 0;
		z-index: 999;
		background-color: #f2f2f2;
		height: 60px;
		/* padding-top: 5px; */
	}

	.hand-nav .el-menu-demo {
		width: 1280px;
		margin: 0 auto;
	}

	.el-menu--horizontal .el-menu-item {
		font-size: 16px;
		/* height: 70px;
		line-height: 70px; */
	}

	.el-menu--horizontal .el-submenu .el-submenu__title {
		font-size: 16px;
		/* height: 70px;
		line-height: 70px; */
	}

	.el-menu-item * {
		vertical-align: unset;
	}

	.hotlinePhone {
		font-size: 26px;
		color: #007985;
		font-weight: bold;
		letter-spacing: 2px;
	}

	.hotlinePhone i {
		font-size: 30px;
		width: 40px;
		color: #007985;
	}

	.hotlinePhone span {
		vertical-align: middle;
	}

	.not-Mouse-hand {
		cursor: default;
	}

	.el-menu-item:hover {
		background: #f2f2f2 !important;
	}

	.el-submenu__title:hover {
		background: #f2f2f2 !important;
	}
</style>
<style scoped>
	.el-menu.el-menu--horizontal {
		border-bottom: 0px;
	}

	.el-menu--horizontal a {
		color: #000;
		text-decoration: none;
	}
</style>

<style scoped>
	/* 页脚 */
	.footer {
		font-family: Noto Sans CJK SC, Source Han Sans SC, Microsoft YaHei, Source Han Sans CN, sans-serif;
		font-size: 14px;
		background: #1a1a1a;
		padding: 50px 0px;
	}

	.footer .main {
		max-width: 1220px !important;
		margin: 0 auto !important;
		padding: 0px 10px;
	}

	.footer .main .had {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.footer .main .had dl {
		text-align: center;
		margin: 0;
	}

	.footer .main .had dl dt {
		font-size: 16px;
		color: #fff;
		margin-bottom: 15px;
	}

	.footer .main .had dl dd {
		font-size: 14px;
		margin: 0;
		padding: 0;
		font-weight: normal;
	}

	.footer .main .had dl dd a {
		padding: 0px 10px;
		color: #bbbbbb;
		margin-top: 10px;
		display: inline-block;
		vertical-align: top;
		background: transparent;
		text-decoration: none;
	}

	.footer .main .had .log_row {
		height: 80px;
		line-height: 80px;
		font-size: 16px;
	}

	.footer .main .had .address {
		text-align: left;
		padding-left: 20px;
		line-height: 40px;
	}

	.footer .main .link {
		line-height: 40px;
		height: 40px;
		text-align: left;
		margin-left: 100px;
	}

	.footer .main .link a {
		color: #bbbbbb;
		text-decoration: none;
	}

	.footer .main .link .title {
		font-size: 16px;
		line-height: 80px;
	}

	.footer .main .dwo {
		border-top: 1px solid #727272;
		margin-top: 30px;
		padding-top: 30px;
	}

	.footer .main .dwo p {
		color: #bbbbbb;
		line-height: 25px;
		padding: 0;
		margin: 0;
	}

	.footer .main .dwo p a {
		display: inline-block;
		vertical-align: middle;
		margin-left: 5px;
		background: transparent;
		text-decoration: none;
		padding: 0;
		margin: 0;
	}

	.footer .main .dwo p a img {
		width: 23px;
		margin-top: -3px;
	}
</style>